import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { map, Observable, Subscription, take, tap } from 'rxjs';
import { SlbBaseSitesService } from './slb-base-sites.service';
import { environment } from 'environments/environment';
import { SlbMessagesService } from './slb-messages.service';

@Injectable({
  providedIn: 'root'
})
export class SlbRedirectService {
  private subscriptions: Subscription = new Subscription();
  private baseSiteService = inject(SlbBaseSitesService);
  private activaCartService = inject(ActiveCartFacade);
  private globalMessageService = inject(SlbMessagesService); 
  private router = inject(Router);

  constructor(
  ) {
  }

  redirect(url: string, target: string, usePath: boolean = true): void {
    this.subscriptions.add(
      this.baseSiteService.getActive().pipe(
        take(1),
        tap(() => this.activaCartService.reloadActiveCart()),
        tap(() => this.globalMessageService.reset()),
        tap((baseSite) => {
          if (usePath) {
            if (target === '_self') {
              this.router.navigateByUrl(`${baseSite?.uid}/${environment.appConfig.language}/${environment.appConfig.currency}${url}`);
            } else {
              window.open(`${baseSite?.uid}/${environment.appConfig.language}/${environment.appConfig.currency}${url}`, target);
            }
          } else {
            window.open(`${url}`, target);
          }
        })
      ).subscribe()
    );
  }

  replace(url: string): void {
    this.subscriptions.add(
      this.baseSiteService.getActive().pipe(
        take(1),
        tap((baseSite) => {
            this.router.navigateByUrl(`${baseSite?.uid}/${environment.appConfig.language}/${environment.appConfig.currency}${url}`);
        })
      ).subscribe()
    )
  }

  getBasePathName(): Observable<string> {
    return this.baseSiteService.getActive().pipe(
      take(1),
      map((site) => {
        const baseSite = site?.uid;
        const language = environment.appConfig.language[0];
        const currency = environment.appConfig.currency[0];

        return `/${baseSite}/${language}/${currency}`;
      })
    )

  }
}
